<template>
  <MainMenu>
    <slot></slot>
  </MainMenu>
</template>

<script>
import MainMenu from "@/components/MainMenu";

export default {
  name: "LayoutSite",
  components: {
    MainMenu
  },
  data: () => ({
    //
  }),
  created() {
    let usuarioAux = sessionStorage.getItem("usuario");
    if (usuarioAux) {
      this.usuario = JSON.parse(usuarioAux);
    } else {
      window.location.href = window.location.origin + "/login";
    }
  }
};
</script>
